const animationParagraphBisEffect = (container) => {
  if (container.querySelectorAll('div.text-effect-bis > p') || container.querySelectorAll('div.text-effect-bis > .wp-block-group__inner-container > p')) {
    let wrapper = container.querySelectorAll('div.text-effect-bis');

    for (let i = 0; i < wrapper.length; i++) {
      let elements;

      if( wrapper[i].classList.contains('wp-block-group')) {
        elements = wrapper[i].querySelectorAll('div.text-effect-bis > .wp-block-group__inner-container > p');
      } else {
        elements = wrapper[i].querySelectorAll('div.text-effect-bis > p');
      }

      if (elements) {
        gsap.set(elements, { y: +50, autoAlpha: 0 });
  
        ScrollTrigger.batch(elements, {
          interval: 0.1, // time window (in seconds) for batching to occur.
          onEnter: (batch) =>
            gsap.to(batch, {
              duration: 0.6,
              delay: 0.6,
              y: 0,
              autoAlpha: 1,
              ease: 'power1.out',
              stagger: 0.5,
              overwrite: true,
            }),
          start: 'top bottom',
        });
      }
    }
  }
};

export default animationParagraphBisEffect;
